var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconForInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.564,
    height: 9.564,
    viewBox: "0 0 9.564 9.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17915",
    "data-name": "Path 17915",
    d: "M14.759,5.627a.722.722,0,0,0-1.023,0l-3.547,3.54L6.642,5.62A.723.723,0,0,0,5.62,6.642l3.547,3.547L5.62,13.736a.723.723,0,1,0,1.023,1.023l3.547-3.547,3.547,3.547a.723.723,0,1,0,1.023-1.023l-3.547-3.547,3.547-3.547A.727.727,0,0,0,14.759,5.627Z",
    transform: "translate(-5.407 -5.407)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconForInfo);
export default __webpack_public_path__ + "static/media/closeIconForInfo.7094a2a7ae5009a6c23b8be33280020b.svg";
export { ForwardRef as ReactComponent };